export default __webpack_public_path__ + "static/placeholder-244b6eef2defe004b2603460aea7d8d3.svg";